import { render } from "./SliderUltimaTecnologia.vue?vue&type=template&id=130a465b&scoped=true"
import script from "./SliderUltimaTecnologia.vue?vue&type=script&lang=js"
export * from "./SliderUltimaTecnologia.vue?vue&type=script&lang=js"

import "./SliderUltimaTecnologia.vue?vue&type=style&index=0&id=130a465b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130a465b"]])

export default __exports__